import { Clickable } from '../@shared/models/clickable.model';

export class GLPDATA {
    constructor() {
        this.title = { text: '' };
        this.feed = [];
    }

    title: { text: string };
    feed: Array<Feed>;
}

export interface Feed {
    icon: string;
    link: string;
    text: string;
}
